<template>
  <div class="videoShare" v-if="!loading">
    <img class="bg" src="./image/bg.png" alt="bg">
    <div class="org">
      <img src="./image/icon-org.png" alt="org">
      <span>{{videoDto.org}}</span>
    </div>
    <img class="avatar" :src="videoDto.avatarUrl" alt="avatar">
    <div class="cover">
      <img
        :style="{width:isLandscape?'auto':'100%',height:isLandscape?'100%':'auto',}"
        :src="videoDto.thumbnail"
        alt="cover"
      >
    </div>
    <img class="play" @click="handlePlayVideo" src="./image/play.png" alt="play">
    <div class="user-name">{{videoDto.userName}}</div>
    <div class="title-box">
      <img src="./image/bg-title.png" alt="bg-title">
      <p>{{videoDto.title}}</p>
      <span>{{videoDto.releaseTime}}</span>
    </div>

    <div class="video-box" id="video-box" :class="[videoShow?'video-show':'']">
      <div class="bg-video">
        <img
          :style="{width:isLandscape?'auto':'100%',height:isLandscape?'100%':'auto',}"
          :src="videoDto.thumbnail"
          alt="bgvideo"
        >
        <span></span>
      </div>
      <video
        :src="videoDto.videoUrl"
        id="video"
        preload="auto"
        loop="loop"
        playsinline
        webkit-playsinline="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        :x5-video-orientation="isLandscape?'landscape':'portrait'"
        :style="videoStyle"
      />
      <div class="back" v-if="showBack" @click="handleBack">
        <img src="./image/back.png" alt="back">
      </div>
      <div class="watermark" :style="{top:isIos?'18px':'60px'}">
        <p>{{videoDto.userName}}</p>
        <p>{{videoDto.org}}</p>
      </div>
      <div class="refresh ani-rolling" v-if="refreshing"></div>
    </div>

    <div
      v-if="remarkDtoList.length"
      class="comment"
      id="comment"
      :style="{bottom:isReachBottom?'auto':'0'}"
    >
      <div class="comment-header">收获 {{videoDto.remarkNum}} 条评论</div>
      <div class="comment-content">
        <div class="comment-item" v-for="item in remarkDtoList" :key="item.id">
          <div class="item-info">
            <img :src="item.avatarUrl||defaultAvatar" alt="avatar">
            <h3>{{item.userName}}</h3>
            <span>{{item.remarkTime}}</span>
          </div>
          <div class="item-text">{{item.remarkText}}</div>
        </div>
      </div>
      <div class="comment-footer">
        <span>打开UPKID查看全部评论</span>
      </div>
    </div>
    <div
      v-else
      class="comment-empty"
      id="comment-empty"
      :style="{bottom:isReachBottom?'auto':'0',top:isReachBottom?'10.56rem':'auto'}"
    >
      <img src="./image/monkey.png" alt="monkey">
      <div class="comment-empty-desc">打开UPKID去看更多视频~</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { setTimeout } from 'timers'
export default {
  data () {
    return {
      videoDto: '',
      remarkDtoList: [],
      videoShow: false,
      showBack: true,
      isIos: true,
      isReachBottom: true,
      refreshing: false,
      isLandscape: false, // 是否横屏
      videoStyle: ''
    }
  },
  computed: {
    ...mapGetters([
      'defaultAvatar',
      'loading'
    ])
  },
  created () {
    // console.log(this.$route.params)
    this.apiGetVideoInfo()
  },
  mounted () { },
  methods: {
    handlePlayVideo () {
      this.videoShow = true
      this.vobj.play()
    },
    handleBack () {
      this.vobj.pause()
      this.videoShow = false
    },
    setTimeout20 () {
      setTimeout(() => {
        this.vobj = document.getElementById('video')

        this.vobj.addEventListener('x5videoenterfullscreen', () => {
          this.showBack = false
          this.isIos = false
          this.videoStyle = ''
        })
        this.vobj.addEventListener('x5videoexitfullscreen', () => {
          this.vobj.pause()
          this.videoShow = false
          this.isIos = true
          this.videoStyle = {
            transform: this.isLandscape ? `translate(-50%, -50%) rotate(${this.videoRotate}deg)` : 'translate(-50%, -50%) rotate(0deg)',
            width: this.isLandscape ? this.bodyHeight : this.bodyWidth,
            height: this.isLandscape ? this.bodyWidth : this.bodyHeight
          }
        })

        // 设置加载刷新
        this.vobj.addEventListener('waiting', () => {
          // console.log('waiting')
          this.refreshing = true
        })

        this.vobj.addEventListener('canplay', () => {
          // console.log('canplay')
          this.refreshing = false
        })

        const videoBox = document.getElementById('video-box')
        videoBox.addEventListener('touchmove', function (e) {
          e.preventDefault()
        }, false)

        const docsh = document.documentElement.scrollHeight
        if (this.remarkDtoList.length) {
          const comment = document.getElementById('comment')
          const rb = comment.getBoundingClientRect().bottom
          // console.log(docsh)
          // console.log(rb)
          this.isReachBottom = Math.abs(docsh - rb) < 1
        } else {
          const commentEmpty = document.getElementById('comment-empty')
          const rb = commentEmpty.getBoundingClientRect().bottom
          this.isReachBottom = Math.abs(docsh - rb) < 1
        }
      }, 20)
    },
    setVideoStyleAndIsLandscape (duration) {
      const deg = duration.split('#')[1]
      switch (parseInt(deg)) {
        case 0:
          this.isLandscape = false
          break
        case 90:
          this.isLandscape = true
          this.videoRotate = 90
          break
        case 180:
          this.isLandscape = false
          break
        case 270:
          this.isLandscape = true
          this.videoRotate = 270
      }

      this.bodyHeight = document.documentElement.clientHeight + 'px'
      this.bodyWidth = document.documentElement.clientWidth + 'px'
      this.videoStyle = {
        top: '50%',
        left: '50%',
        transform: this.isLandscape ? `translate(-50%, -50%) rotate(${this.videoRotate}deg)` : 'translate(-50%, -50%) rotate(0deg)',
        width: this.isLandscape ? this.bodyHeight : this.bodyWidth,
        height: this.isLandscape ? this.bodyWidth : this.bodyHeight
      }
    },
    apiGetVideoInfo (code) {
      this.$axios({
        method: 'post',
        url: `/video/shareVideoToWechat/${this.$route.params.vid}/${this.$route.params.uid}`
      }).then((res) => {
        this.videoDto = res.data.data.userVideoDto
        this.remarkDtoList = res.data.data.userVideoRemarkDtoList
        this.setLoading(false)
        this.setTimeout20()
        this.setVideoStyleAndIsLandscape(res.data.data.userVideoDto.duration)
      }).catch((err) => {
        console.log(err)
      })
    },
    ...mapMutations({
      setLoading: 'SET_LOADING'
    })
  }
}
</script>

<style lang="scss" scoped>
.videoShare {
  position: relative;
  width: 100%;
  height: 100%;
}
.bg {
  width: 100%;
  position: relative;
  z-index: 1;
}
.org {
  position: absolute;
  top: 0.4rem;
  left: 0.42rem;
  z-index: 2;
  display: flex;
  align-items: center;
  height: 0.48rem;
  img {
    margin-right: 0.08rem;
    width: 0.48rem;
    height: 0.48rem;
  }
  span {
    line-height: 0.44rem;
    font-size: 0.32rem;
    color: #626262;
  }
}
.avatar {
  position: absolute;
  top: 3.8rem;
  left: 1.6rem;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  z-index: 2;
}
.cover {
  position: absolute;
  top: 3.2rem;
  left: 3.7rem;
  width: 2.9rem;
  height: 3.4rem;
  transform: rotate(-10deg);
  z-index: 0;
  overflow: hidden;
  border-radius: 0.08rem;
  img {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // width: 100%;
    // height: 100%;
  }
}
.play {
  position: absolute;
  top: 4.04rem;
  left: 4.48rem;
  width: 1.28rem;
  height: 1.28rem;
  z-index: 2;
  transform: translateZ(0);
  animation: heartbeat infinite 0.7s ease-out;
}
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1.2);
  }
  75% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.user-name {
  position: absolute;
  top: 5.72rem;
  left: 4.56rem;
  width: 1.74rem;
  line-height: 0.44rem;
  text-align: center;
  font-size: 0.28rem;
  font-weight: 500;
  color: #ffffff;
  z-index: 2;
  transform: rotate(-10deg);
}
.title-box {
  position: absolute;
  top: 8.1rem;
  left: 50%;
  transform: translateX(-50%);
  width: 7.22rem;
  height: 2.24rem;
  z-index: 2;
  img {
    width: 100%;
    height: 100%;
  }
  p {
    position: absolute;
    top: 0.76rem;
    left: 0.56rem;
    width: 6.1rem;
    line-height: 0.44rem;
    font-size: 0.28rem;
    font-weight: 500;
    color: #ffffff;
  }
  span {
    position: absolute;
    right: 0.46rem;
    bottom: 0.46rem;
    line-height: 0.36rem;
    font-size: 0.24rem;
    color: #ffffff;
    opacity: 0.6;
  }
}

.video-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -5;
  opacity: 0;
  .bg-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    img {
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      // height: 100%;
      z-index: 1;
    }
    span {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
  video {
    position: relative;
    left: 0;
    top: 0;
    z-index: 2;
    // transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .back {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 3;
    padding: 20px 10px;
    img {
      width: 25px;
      height: 25px;
    }
  }
  .watermark {
    position: absolute;
    top: 9px;
    right: 8px;
    z-index: 3;
    p {
      line-height: 18px;
      text-align: right;
      font-size: 13px;
      font-weight: 500;
      color: #ffffff;
      text-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
    }
  }
}
.video-show {
  z-index: 5;
  opacity: 1;
}

.comment {
  position: absolute;
  top: 10.56rem;
  bottom: auto;
  left: 0;
  z-index: 2;
  padding-bottom: 0.34rem;
  width: 100%;
  border-top-left-radius: 0.2rem;
  border-top-right-radius: 0.2rem;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}
.comment-empty {
  position: absolute;
  top: 10.56rem;
  bottom: auto;
  left: 0;
  z-index: 2;
  width: 100%;
  border-top-left-radius: 0.2rem;
  border-top-right-radius: 0.2rem;
  padding-top: 0.38rem;
  padding-bottom: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.06rem;
  background-color: #ffffff;
  img {
    margin-right: 0.04rem;
    width: 1.06rem;
    height: 1.02rem;
    border-radius: 50%;
  }
  .comment-empty-desc {
    width: 5.6rem;
    height: 0.84rem;
    line-height: 0.84rem;
    text-align: center;
    font-size: 0.32rem;
    color: #ff6010;
    background: url(./image/bg-bubble.png) no-repeat center center;
    background-size: 100% 100%;
  }
}
.comment-header {
  padding: 0.16rem 0.2rem;
  line-height: 0.48rem;
  font-size: 0.32rem;
  color: #626262;
  border-bottom: 0.02rem solid #f0f0f0;
}
.comment-content {
  flex: 1;
  padding: 0 0.4rem;
}
.comment-item {
  margin-top: 0.4rem;
}
.item-info {
  display: flex;
  align-items: center;
  height: 0.72rem;
  img {
    width: 0.72rem;
    height: 0.72rem;
    border-radius: 50%;
  }
  h3 {
    margin-left: 0.1rem;
    line-height: 0.48rem;
    font-size: 0.32rem;
    font-weight: 500;
    color: #626262;
  }
  span {
    flex: 1;
    text-align: right;
    line-height: 0.44rem;
    font-size: 0.24rem;
    color: #d8d8d8;
  }
}
.item-text {
  margin-top: 0.1rem;
  line-height: 0.44rem;
  font-size: 0.28rem;
  color: #626262;
}
.comment-footer {
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 7.06rem;
  height: 0.84rem;
  span {
    line-height: 0.5rem;
    font-size: 0.32rem;
    color: #626262;
  }
  &::before {
    flex: 1;
    content: "";
    border-bottom: 1px dashed #d8d8d8;
  }
  &::after {
    flex: 1;
    content: "";
    border-bottom: 1px dashed #d8d8d8;
  }
}
.refresh {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateZ(0);
  margin-left: -21px;
  margin-top: -21px;
  width: 42px;
  height: 42px;
  z-index: 10;
  box-sizing: border-box;
  border: 4px solid #666666;
  border-top-color: transparent !important;
  border-radius: 50%;
}
.ani-rolling {
  animation: rolling 0.6s linear infinite;
}
@keyframes rolling {
  0% {
    transform: rotate(135deg);
  }
  100% {
    transform: rotate(495deg);
  }
}
</style>
